import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import {  Container } from 'semantic-ui-react'

export const LoginPage = ({ firebase, auth }) => (
  <Container>

    <div>

      {
        !isLoaded(auth)
        ? <span>Loading...</span>
        : isEmpty(auth)
          ? <div><h2>become god</h2><button onClick={() => firebase.login({ provider: 'google', type: 'popup' })}>Login With Google</button></div>
          : <div><h2>became god</h2><span>You are logged in</span></div>
      }
    </div>
  </Container>
)

LoginPage.propTypes = {
  firebase: PropTypes.shape({
    login: PropTypes.func.isRequired
  }),
  auth: PropTypes.object
}

export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(LoginPage)



// WEBPACK FOOTER //
// ./src/components/pages/admin/Login.js